import { Stack } from "@mui/material";
import React from "react";
import styled from "styled-components";
import { useScreenWidthRange } from "../LandingOne";

const StatsSection = () => {
  const isTablet = useScreenWidthRange(768, 1024);
  const isMobile = useScreenWidthRange(0, 767);
  const statsData = [
    {
      label: "Capacity Unlocked",
      value: "+18%",
      sub: "MoM shipment growth after switching to Majura"
    },
    {
      label: "Hours Saved Per Week",
      value: "24 Hrs",
      sub: "We free up a day each week from paperwork"
    },
    {
      label: "Customs Docs Done",
      value: "9x",
      sub: "Faster processing cut from 3 h to 20 min"
    }
  ];

  return (
    <Stack
      direction={"column"}
      spacing={'50px'}
      sx={{
        width: "100%",
        alignItems: "center",
        maxWidth: "1100px",
        marginLeft: "auto",
        marginRight: "auto"
      }}
    >
      <Stack
        direction={"column"}
        spacing={isTablet || isMobile ? '0px' : "24px"}
        sx={{ width: "100%", alignItems: "center" }}
      >
        <div style={{ textAlign: "center", width: "100%" }}>
          <Subheading>We don't like to brag,</Subheading>
          <MainHeadingContainer>
            <MainHeading>
              But our users save hours a day and thousands a month
            </MainHeading>
          </MainHeadingContainer>
        </div>

        <Stack
          direction={isTablet || isMobile ? "column" : "row"}
          sx={{
            width: !isTablet && !isMobile ? "100%" : "fit-content",
            padding: isTablet || isMobile ? "0 48px !important" : "0"
          }}
        >
          {statsData.map((stat, index) => (
            <React.Fragment key={index}>
              <StatCard>
                <StatLabel>{stat.label}</StatLabel>
                <StatValue>{stat.value}</StatValue>
                <StatSub>{stat.sub}</StatSub>
              </StatCard>
              {index < statsData.length - 1 && <Divider />}
            </React.Fragment>
          ))}
        </Stack>
      </Stack>

      <FooterContainer>
        <FooterNote>
          Join the growing network of 900+ forwarders who ditched the busywork
        </FooterNote>
      </FooterContainer>
    </Stack>
  );
};

const Divider = styled.div`
  width: 1px;
  background-color: #eee;
`;

const Subheading = styled.p`
  color: #4f79ff;
  font-weight: 600;
  letter-spacing: 1px;
  font-size: 0.9rem;
  text-transform: uppercase;
`;

const MainHeadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 767px) {
    padding: 0px 32px;
    margin-top: 0px;
    margin-bottom: 0px;
  }
`;

const MainHeading = styled.h2`
  font-size: 2rem;
  font-weight: 700;
  color: #0a1f60;
  margin-top: 0.5rem;
  text-align: center;

  @media (min-width: 600px) {
    font-size: 2.5rem;
    font-weight: 500;
  }
`;

const StatCard = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  // border-right: 1px solid #eee;

  &:last-child {
    border-right: none;
  }

  @media (max-width: 1025px) {
    padding: 24px;
    border-right: none;
    border-bottom: 1px solid #eee;

    &:last-child {
      border-bottom: none;
    }
  }
`;

const StatLabel = styled.p`
  color: #333;
  font-weight: 600;
  font-size: 1.2rem;

  @media (max-width: 1025px) {
    font-size: 1rem;
    text-align: center;
  }
`;

const StatValue = styled.p`
  font-size: 6rem;
  color: #0277ff;
  margin: 0 0;
  line-height: 1;

  @media (max-width: 1025px) {
    font-size: 3.75rem;
    text-align: center;
  }
`;

const StatSub = styled.p`
  color: #888;
  font-size: 0.9rem;
  text-align: center;
`;

const FooterContainer = styled.div`
  margin: 8rem 0rem;
  text-align: center;

  @media (max-width: 1025px) {
    padding: 0 32px;
  }
`;

const FooterNote = styled.p`
  font-weight: 600;
  font-size: 2rem;
  color: #0a1f60;

  @media (max-width: 767px) {
    margin: 0px;
    font-size: 1.75rem;
    line-height: 1.3;
    font-weight: 500;
  }
`;

export default StatsSection;
